import {_} from 'lodash';
import * as ko from "knockout";
import {TBaseOrObservableType} from "../../../index";

export interface IInputObjectParams<TObservableType> {
    isValid?: (val: TObservableType) => boolean
    value: TBaseOrObservableType<TObservableType>
    type: HTMLInputElement['type']
    attr?: Partial<Record<keyof HTMLInputElement, any>>
    ph?: TBaseOrObservableType<string>
    tt?: TBaseOrObservableType<string>
    event?: Partial<Record<keyof GlobalEventHandlersEventMap, (obj: InputObject<TObservableType>, event: JQuery.Event) => void>>
}

export class InputObject<TObservableType> {
    public obs: KnockoutObservable<TObservableType | null> = ko.observable(null)

    constructor(private params: IInputObjectParams<TObservableType>) {
        if (ko.isObservable(params.value)) {
            this.obs = params.value as KnockoutObservable<TObservableType | null>
        } else {
            this.obs(params.value as TObservableType)
        }
    }

    public isValid(): boolean {
        const val = this.obs();
        return val == null ? false : (this.params.isValid?.(val) ?? true)
    }

    public getInitBindings() {
        const ret: any = {
            attr: _.defaultsDeep({
                type: this.params.type,
            }, this.params.attr ?? {}),
            cls: ko.computed(() => this.getCssClass()),
            event: this.params.event ?? {},
            ph: this.params.ph,
            tt: this.params.tt,
        }
        switch (this.params.type) {
            case 'checkbox': {
                ret.checked = this.obs
                break;
            }
            default: {
                ret.textInput = this.obs
                break;
            }
        }
        return ret
    }

    public getCssClass(): string {
        return this.isValid() ? '' : 'warning'
    }

}